import PdfIcon from "@/assets/icons/pdf.svg?react";
import XlsIcon from "@/assets/icons/xls.svg?react";
import { Button } from "@/components/ui/button";
import { useApplicationByEdition } from "@/hooks/application-by-edition.hook";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useExportQuizWithAnswersMutation } from "@/hooks/export-quiz-with-answers-mutation.hook";
import { useDownloadResultsFileMutation } from "@/hooks/reports/download-results-file-mutation.hook";
import { cn } from "@/lib/utils";
import { Eye, FileBadge } from "lucide-react";
import { FC, HTMLAttributes } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";

type ActionsCellProps = HTMLAttributes<HTMLDivElement> & {
  editionId: string;
};

export const ActionsCell: FC<ActionsCellProps> = ({ editionId, ...props }) => {
  const mutation = useDownloadResultsFileMutation();
  const exportMutation = useExportQuizWithAnswersMutation();

  const { data: userProfile } = useCurrentUserProfile();

  const { data: application } = useApplicationByEdition({
    companyId: userProfile?.companyId || "",
    editionId: editionId,
  });

  const downloadPdfReport = () => {
    const promise = mutation.mutateAsync({
      companyId: userProfile?.companyId || "",
      applicationQuizId: application?.quizId || "",
    });

    toast.promise(promise, {
      loading: "Preparando reporte en PDF...",
      success: () => {
        return "Reporte en PDF listo.";
      },
    });
  };

  const downloadExcelReport = () => {
    const promise = exportMutation.mutateAsync({
      companyId: userProfile?.companyId || "",
      quizId: application?.quizId || "",
    });

    toast.promise(promise, {
      loading: "Preparando reporte en Excel...",
      success: () => {
        return "Reporte en Excel listo.";
      },
    });
  };

  return (
    <div className={cn("inline-flex", props.className)}>
      <Button
        className="shrink-0"
        variant={"ghost"}
        size={"icon"}
        disabled={!application}
        title="Ver resumen"
        onClick={(e) => {
          e.stopPropagation();
        }}
        asChild
      >
        <Link to={`/previous-editions/${editionId}`}>
          <Eye className="!h-6 !w-6" color="#615CB7" />
        </Link>
      </Button>

      <Button
        className="shrink-0"
        variant={"ghost"}
        size={"icon"}
        disabled={!application}
        title="Ver reporte completo"
        onClick={(e) => {
          e.stopPropagation();
        }}
        asChild
      >
        <Link
          to={`/editions/${editionId}/quizzes/${application?.quizId}/results/general?ref=previous-editions`}
        >
          <FileBadge className="!h-6 !w-6" color="#615CB7" />
        </Link>
      </Button>

      <Button
        className="shrink-0"
        variant={"ghost"}
        size={"icon"}
        disabled={!application}
        onClick={(e) => {
          e.stopPropagation();
          downloadPdfReport();
        }}
        title="Descargar PDF"
      >
        <PdfIcon className="!h-7 !w-7" />
      </Button>

      <Button
        className="shrink-0"
        variant={"ghost"}
        size={"icon"}
        disabled={!application}
        onClick={(e) => {
          e.stopPropagation();
          downloadExcelReport();
        }}
        title="Descargar Excel"
      >
        <XlsIcon className="!h-7 !w-7" />
      </Button>
    </div>
  );
};
